import React from "react";
import Modal from "react-modal";
import config from "../config";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { formatConversationDuration, formatDate } from "../utils/helpers";

const DisplayData = ({ customer, isOpen, closeModal }) => {
  if (!customer || !customer.cdr) {
    return null;
  }

  const buildAudioUrl = (record, customerId) => {
    const date = record.calldate.split("T")[0];
    return `${config.url_get_audio}getAudioRange?s=${record.linkedid}&client_id=${customerId}&src=${record.src}&calldate=${date}`;
  };

  const getRowStyle = (disposition) => ({
    backgroundColor: disposition === "ANSWERED" ? "#27ae60" : "#34495e",
    color: "white",
  });

  const records = customer.cdr.map((record, idx) => {
    const audioPlayer = record.billsec ? (
      <AudioPlayer
        key={`audio-${record.linkedid}-${idx}`}
        src={buildAudioUrl(record, customer.id)}
        style={{ minWidth: "300px" }}
      />
    ) : null;

    const duration = formatConversationDuration(
      record.disposition === "ANSWERED" ? record.billsec : 0
    );

    return (
      <tr key={`record-${idx}`} style={getRowStyle(record.disposition)}>
        <td style={{ padding: "12px" }}>{formatDate(record.calldate)}</td>
        <td style={{ padding: "12px" }}>
          <span
            style={{
              padding: "4px 8px",
              borderRadius: "4px",
              backgroundColor:
                record.disposition === "ANSWERED" ? "#2ecc71" : "#e74c3c",
              fontSize: "12px",
            }}
          >
            {record.disposition}
          </span>
        </td>
        <td style={{ padding: "12px" }}>{duration}</td>
        <td style={{ padding: "12px" }}>{record.src}</td>
        <td style={{ width: "400px", padding: "8px" }}>{audioPlayer}</td>
      </tr>
    );
  });

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="CDR"
      ariaHideApp={false}
      onRequestClose={closeModal}
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          maxWidth: "95vw",
          maxHeight: "90vh",
          overflow: "auto",
          padding: "20px",
          borderRadius: "8px",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.75)",
        },
      }}
    >
      <div
        style={{
          marginBottom: "20px",
          borderBottom: "2px solid #eee",
          paddingBottom: "15px",
        }}
      >
        <h1 style={{ color: "#333", marginBottom: "10px", fontSize: "24px" }}>
          Detalii client ID: {customer.id}
        </h1>
        <p style={{ color: "#666", margin: 0 }}>
          Total inregistrari: {customer.cdr.length}
        </p>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table
          className="table table-striped table-bordered"
          style={{ minWidth: "800px" }}
        >
          <thead style={{ backgroundColor: "#f8f9fa" }}>
            <tr>
              <th style={{ padding: "12px", fontWeight: "600" }}>Data & Ora</th>
              <th style={{ padding: "12px", fontWeight: "600" }}>Status</th>
              <th style={{ padding: "12px", fontWeight: "600" }}>Durata</th>
              <th style={{ padding: "12px", fontWeight: "600" }}>Telefon</th>
              <th style={{ padding: "12px", fontWeight: "600" }}>
                Inregistrare
              </th>
            </tr>
          </thead>
          <tbody>{records}</tbody>
        </table>
      </div>

      <div
        style={{
          marginTop: "20px",
          textAlign: "right",
          borderTop: "1px solid #eee",
          paddingTop: "15px",
        }}
      >
        <button
          onClick={closeModal}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          Inchide
        </button>
      </div>
    </Modal>
  );
};

export default DisplayData;
